Cache = require("cache");
var ApiCache = new Cache(15 * 60 * 1000); //1000 = 1 sec

class cache
{
    constructor(props)
    {

    }
    
    get(key)
    {
        return ApiCache.get(key);
    }
    
    put(key, value)
    {
        ApiCache.put(key, value);
    }
    
    del(key)
    {
        ApiCache.del(key);
    }
}

export default new cache();